// CreditReviewForm.jsx (dengan summary + readonly jika recommended)
import {
  Collapse,
  DatePicker,
  Input,
  Select,
  message,
  Modal,
  Button,
  Spin,
  Descriptions,
  Typography,
} from "antd";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import useRoleAccess from "@/hooks/useRoleAccess";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Option } = Select;
const { Title } = Typography;

const CreditReviewForm = ({ pemohonData = {} }) => {
  const { application_id, nik } = useParams();
  const navigate = useNavigate();
  const { isViewer } = useRoleAccess();

  const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2;

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL2}/api/credit-review/${application_id}/${nik}`
        );
        if (res.data) {
          setFormData({
            ...res.data,
            phone_verif_date: res.data.phone_verif_date
              ? dayjs(res.data.phone_verif_date)
              : null,
          });
          if (res.data.recommended === true || res.data.recommended === false) {
            setIsReadOnly(true);
          }
        }
      } catch (err) {
        console.log("Belum ada data. Form baru dibuka.");
        setFormData({ application_id, nik });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [application_id, nik]);

  const handleChange = (key, value) => {
    if (!isReadOnly) {
      setFormData((prev) => ({ ...prev, [key]: value }));
    }
  };

  // const submitForm = async (recommend) => {
  //   try {
  //     const payload = {
  //       ...formData,
  //       phone_verif_date: formData.phone_verif_date
  //         ? dayjs(formData.phone_verif_date).format("YYYY-MM-DD")
  //         : null,
  //       recommended: recommend,
  //       created_by: "cmo_salman",
  //     };

  //     await axios.post("http://217.196.49.162:3001/api/credit-review", payload);

  //     Modal.success({
  //       title: "Berhasil",
  //       content: recommend
  //         ? "Debitur berhasil direkomendasikan ✅"
  //         : "Debitur tidak direkomendasikan ❌",
  //       onOk: () => navigate("/approval"),
  //     });
  //   } catch (error) {
  //     console.error(error);
  //     message.error("Gagal menyimpan data.");
  //   }
  // };

  const namanya = localStorage.getItem("namanya");
  const submitForm = async (recommend) => {
  try {
    const payload = {
      ...formData,
      phone_verif_date: formData.phone_verif_date
        ? dayjs(formData.phone_verif_date).format("YYYY-MM-DD")
        : null,
      recommended: recommend,
      created_by: namanya,
    };

    // Kirim credit review
    await axios.post(`${API_BASE_URL2}/api/credit-review`, payload);

    // Update status langsung ke APPV-1
    await axios.put(`${API_BASE_URL2}/api/updatestatus/${application_id}/${nik}`, {
      status: "APPV-1",
    });

    Modal.success({
      title: "Berhasil",
      content: recommend
        ? "Debitur berhasil direkomendasikan ✅"
        : "Debitur tidak direkomendasikan ❌",
      onOk: () => navigate("/approval"),
    });
  } catch (error) {
    console.error(error);
    message.error("Gagal menyimpan data.");
  }
};


  const renderInput = (label, key) => {
    if (/tanggal|date/i.test(label)) {
      return (
        <DatePicker
          className="w-full"
          value={formData[key]}
          onChange={(val) => handleChange(key, val)}
          disabled={isReadOnly}
        />
      );
    }
    return (
      <Input
        className="w-full"
        value={formData[key] || ""}
        onChange={(e) => handleChange(key, e.target.value)}
        readOnly={isReadOnly}
      />
    );
  };

  const renderGrid = (fields) => (
    <div className="grid grid-cols-2 gap-4 p-4 bg-white rounded-xl">
      {fields.map(([label, key]) => (
        <div key={key}>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {label}
          </label>
          {renderInput(label, key)}
        </div>
      ))}
    </div>
  );

  if (loading) return <Spin size="large" />;

  return (
    <>
      {isReadOnly && (
        <div className="bg-green-50 border border-green-400 text-green-800 px-4 py-2 mb-4 rounded">
          <Title level={5}>✅ Data ini sudah direview</Title>
          <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label="Hasil Verifikasi">
              {formData.phone_verif_result}
            </Descriptions.Item>
            <Descriptions.Item label="Verifikasi Oleh">
              {formData.phone_verif_by}
            </Descriptions.Item>
            <Descriptions.Item label="Tanggal">
              {formData.phone_verif_date
                ? dayjs(formData.phone_verif_date).format("DD-MM-YYYY")
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Kesimpulan">
              {formData.recommended ? "Direkomendasikan" : "Tidak Direkomendasikan"}
            </Descriptions.Item>
          </Descriptions>
        </div>
      )}

     <Collapse defaultActiveKey={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]}>
        <Panel header="Summary SLIK dan Pefindo" key="1">
          <TextArea
            rows={4}
            value={formData.summary_slik_pefindo || ""}
            onChange={(e) => handleChange("summary_slik_pefindo", e.target.value)}
          />
        </Panel>

        <Panel header="Phone Verification" key="2">
          {renderGrid([
            ["Verification Result No", "phone_verif_result"],
            ["Date", "phone_verif_date"],
            ["Verification By", "phone_verif_by"],
            ["Notes", "phone_verif_notes"],
          ])}
        </Panel>

        <Panel header="Detail Verification" key="3">
          {renderGrid([
            ["Phone Number", "phone_number"],
            ["Notes", "detail_verif_notes"],
          ])}
        </Panel>

        <Panel header="Info Pinjaman" key="4">
          {renderGrid([
            ["Berapa tenor (tahun) debitur?", "tenor_tahun"],
            ["Apakah ada kunjungan dari CMO", "kunjungan_cmo"],
            ["Notes", "pinjaman_notes"],
          ])}
        </Panel>

        <Panel header="Info Kapasitas dan Kondisi" key="5">
          {renderGrid([
            ["Penghasilan debitur pertahun", "penghasilan_pertahun"],
            ["Berapa penghasilan perbulan debitur?", "penghasilan_perbulan"],
            ["Sudah berapa lama tempat tinggal debitur?", "lamatinggal"],
            ["Apa status tempat tinggal debitur?", "status_rumah"],
            ["Notes", "kapasitas_notes"],
          ])}
        </Panel>

        <Panel header="Info Diri Debitur" key="6">
          {renderGrid([
            ["Apakah nama lengkap debitur sesuai?", "nama_debitur_sesuai"],
            ["Mempunyai unit kendaraan lain", "punya_kendaraan_lain"],
            ["Siapakah keluarga yang dijadikan emergency contact?", "emergency_contact_keluarga"],
            ["Apakah nama pasangan sesuai?", "nama_pasangan_sesuai"],
            ["Apakah Bapak/Ibu mengetahui domisili emergency contact saat ini?", "domisili_emergency_contact"],
            ["Alamat lengkap tempat tinggal", "alamat_tinggal"],
            ["Apakah debitur punya KTP?", "punya_ktp"],
            ["Apakah debitur punya NPWP?", "punya_npwp"],
            ["Apakah debitur punya SIM A?", "punya_sim"],
            ["Contacted Number (OVP)", "contacted_number"],
            ["Untuk apa tujuan penggunaan unit?", "tujuan_penggunaan_unit"],
            ["Notes", "diri_notes"],
          ])}
        </Panel>

        <Panel header="Info Unit" key="7">
          {renderGrid([
            ["Jelaskan produk - merk - type - bahan bakar - transmisi - tahun", "spesifikasi_unit"],
            ["Kendaraan - warna kendaraan", "warna_unit"],
            ["Untuk siapa penggunaan unit ini?", "penggunaan_untuk"],
            ["Notes", "unit_notes"],
          ])}
        </Panel>

        <Panel header="Info Pembayaran" key="8">
          {renderGrid([
            ["Berapa pembayaran pertama debitur (total uang muka)?", "pembayaran_pertama"],
            ["Notes", "pembayaran_notes"],
            ["Sumber Dana", "sumber_dana"],
          ])}
        </Panel>

        <Panel header="Info Pekerjaan" key="9">
          {renderGrid([
            ["Apakah pekerjaan debitur?", "pekerjaan_debitur"],
            ["Apa jabatan debitur?", "jabatan_debitur"],
            ["Notes", "pekerjaan_notes"],
          ])}
        </Panel>

        <Panel header="Enhance Due Diligence (Verifikasi Rekening)" key="10">
          {renderGrid([
            ["Nama Bank", "edd_bank"],
            ["Nomor Rekening", "edd_norek"],
            ["Nama pada Rekening", "edd_nama_rek"],
          ])}
        </Panel>

        <Panel header="Enhance Due Diligence (Verifikasi PEP)" key="11">
          {renderGrid([
            ["Nama PEP", "edd_pep_nama"],
            ["Jabatan/Tugas", "edd_pep_jabatan"],
            ["Nama Instansi/Partai", "edd_pep_instansi"],
            ["Hubungan dengan PEP", "edd_pep_hubungan"],
          ])}
        </Panel>
  <Panel header="Identitas Pemilik Manfaat (Benificial Owner)" key="12">
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      columnGap: "32px",
      rowGap: "18px",
      padding: "8px 0",
    }}
  >
    {[
      ["Nama", "nama", pemohonData.nama],
      ["No. KTP", "no_ktp", pemohonData.noKtp],
      ["Jenis Kelamin", "jenis_kelamin", pemohonData.jenisKelamin],
      ["Alamat Pemohon", "alamat_pemohon", pemohonData.alamat],
      ["Agama Pemohon", "agama_pemohon", pemohonData.agama],
      ["Pendidikan", "pendidikan", pemohonData.pendidikan],
      ["Jenis Pekerjaan", "jenis_pekerjaan", pemohonData.jenisPekerjaan],
      ["Warga Negara", "warga_negara", pemohonData.wargaNegara],
      ["Nomor Telepon", "nomor_telepon", pemohonData.nomorTelepon],
      ["No HP", "no_hp", pemohonData.noHp],
    ].map(([label, key, value]) => (
      <div
        key={key}
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(130px, 1fr) 1.2fr",
          alignItems: "start",
          gap: "12px",
        }}
      >
        <span style={{ color: "#777", fontSize: "14px" }}>
          {label}
        </span>

        <span
          style={{
            color: "#262626",
            fontSize: "14px",
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {value ?? "—"}
        </span>
      </div>
    ))}
  </div>
</Panel>
      </Collapse>

      {!isReadOnly && !isViewer && (
        <div className="mt-6 flex gap-4">
          <Button
            type="primary"
            onClick={() =>
              Modal.confirm({
                title: "Konfirmasi",
                content: "Yakin merekomendasikan debitur ini?",
                onOk: () => submitForm(true),
              })
            }
          >
            ✅ Recommended
          </Button>
          <Button
            danger
            onClick={() =>
              Modal.confirm({
                title: "Konfirmasi",
                content: "Yakin TIDAK merekomendasikan debitur ini?",
                onOk: () => submitForm(false),
              })
            }
          >
            ❌ Not Recommended
          </Button>
        </div>
      )}
    </>
  );
};

export default CreditReviewForm;
